<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openSettingForm('')"
          >新 增
        </el-button>
      </template>
    </avue-crud>

    <fee-rule-setting-form
      ref="feeRuleSettingForm"
      @submit="rowSaveRuls"
      @closeSettingForm="onLoad"
    ></fee-rule-setting-form>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/park/vehicle/parkvehicletyperule';
import feeRuleSettingForm from '@/views/v4ward/park/vehicle/parkvehicletyperule-form';
import { mapGetters } from 'vuex';
import { getSpaceTree } from '@/api/v4ward/car/carparkspace';

export default {
  components: { feeRuleSettingForm },
  data() {
    return {
      reWrite: false,
      spaceList: [],
      tempParkingLotId: '',
      firstDisplayFlag: false,
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        dialogClickModal: false,
        align: 'center',
        indexLabel: '序号',
        column: [
          {
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'select',
            editDisabled: true,
            search: true,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场',
                trigger: 'change',
              },
            ],
          },
          {
            label: '收费名称',
            prop: 'name',
            rules: [
              {
                required: true,
                message: '请输入如：小车24小时收费方式/大车早晚收费方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车型',
            prop: 'vehicleType',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=vehicle_type',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请选择车型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '临停车套餐规则ID',
            prop: 'tempcarRuleId',
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入临停车套餐规则ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注信息',
            prop: 'remark',
            type: 'textarea',
            overHidden: true,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkvehicletyperule_add, false),
        viewBtn: this.vaildData(this.permission.parkvehicletyperule_view, false),
        delBtn: this.vaildData(this.permission.parkvehicletyperule_delete, false),
        editBtn: this.vaildData(this.permission.parkvehicletyperule_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
        spaceColumn.dicData = data.data;
        spaceColumn.searchValue = this.spaceList[0].id;
        this.query.parkingLotId = this.spaceList[0].id;
        this.tempParkingLotId = this.spaceList[0].id;
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
  },
  methods: {
    openSettingForm(id) {
      let title = '新增收费规则';
      if (id !== '') {
        title = '修改收费规则';
      }
      this.$refs.feeRuleSettingForm.openDialogForm(title, id);
    },
    rowSaveRuls(dialogForm) {
      console.log(dialogForm);
      add(dialogForm).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      //如果加载列表时parkingLotId为空，则将parkingLotId置为当前的第一个车场
      if (this.query.parkingLotId == undefined || this.query.parkingLotId == '') {
        this.query.parkingLotId = this.tempParkingLotId;
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.parkingLotId = this.spaceList[0].id;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        }
      );
    },
  },
};
</script>

<style></style>
